export interface ChatMessage {
  sender: Sender;
  text: string;
}

export enum Sender {
  USER = 'user',
  BOT = 'bot',
}

export const GENERAL_THREAD_ID = 'general';

export const GENERAL_THREAD_TITLE = 'General chat';

export const MAX_HYDRATED_CONVERSATIONS = 10;

export const kpiThreadId = (kpiId: string): string => `kpi:${kpiId}`;

export const sessionThreadId = (sessionId: string): string => `session:${sessionId}`;

export interface Conversation {
  threadId: string;
  title: string;
  sessionId: string;
  messages: ChatMessage[];
  disableChat: boolean;
  showIntro: boolean;
  showError: boolean;
  loadingHistory: boolean;
}

export interface ConversationSummary {
  threadId: string;
  title: string;
  preview: string;
  active: boolean;
}

export interface PastSession {
  id: string;
  createdAt: string;
}

export interface Usage {
  tenant: string;
  user: string;
  period: string;
  limit: number;
  tokens: {
    input: number;
    output: number;
    total: number;
  };
  remaining: number;
  messages: number;
}

export interface HistoryMessage {
  role: string;
  content: string;
  createdAt: string;
}

export const createConversation = (threadId: string, title: string, sessionId = ''): Conversation => ({
  threadId,
  title,
  sessionId,
  messages: [],
  disableChat: false,
  showIntro: true,
  showError: false,
  loadingHistory: false,
});

export const mapHistoryToMessages = (history: HistoryMessage[]): ChatMessage[] =>
  history.map((entry) => ({
    sender: entry.role === 'user' ? Sender.USER : Sender.BOT,
    text: entry.content,
  }));
